// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1hysx","col":"Table_col__2xFSa","fulfillmentStatus":"Table_fulfillmentStatus__20h-T","emailCol":"Table_emailCol__2e_RD"};